export const ACCEPTED = 'ACCEPTED'
export const WAITING_FOR_DECISION = 'WAITING_FOR_DECISION'
export const DECLINED = 'DECLINED'